import { render, staticRenderFns } from "./detailCom.vue?vue&type=template&id=081b7a84&scoped=true&"
import script from "./detailCom.vue?vue&type=script&lang=ts&"
export * from "./detailCom.vue?vue&type=script&lang=ts&"
import style0 from "./detailCom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailCom.vue?vue&type=style&index=1&id=081b7a84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b7a84",
  null
  
)

export default component.exports